import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import axios from "axios";
import { Checkbox, Input, Radio, Select } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton } from "../../../ui/buttons/Button";

export const ImpSectorLicores = (props) => {
  const [titulo1, setTitulo1] = useState();
  const [titulo2, setTitulo2] = useState();

  useEffect(() => {
    if (props.tabla === 5) {
      setTitulo1(
        "Impresion General de Contribuyentes de Rentas Licores por Sector"
      );
      setTitulo2("Listado General de Contribuyentes Por Sector");
    }
    if (props.tabla === 6) {
      setTitulo1(
        "Declaraciones Anuales de Contribuyentes de Rentas Licores con Deudas"
      );
      setTitulo2("Declaraciones Anuales de Contribuyentes Apuestas Licitas");
    }
    console.log(props.tabla, titulo1, titulo2);
  }, []);

  /*  variables de estados */
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [msg2] = useState();
  const [activate, setActivate] = useState(false);
  const [anio, setAnio] = useState();
  const [visible, setVisible] = useState("hidden");
  const chkActivo = useRef();
  const chkInactivo = useRef();
  const chkClausurado = useRef();
  const chkFiscal = useRef();
  const chkNotificado = useRef();
  const chkDepLegal = useRef();
  const chkExonerado = useRef();
  const chkRevCerrado = useRef();
  const txtTodo = useRef();
  const txtTipo = useRef();
  const txtTipoContri = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const [descripcion, setDescricion] = useState();
  const txtPorRenta = useRef();
  const txtRenta = useRef();
  const txtAnio = useRef();

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tipotasa";
    let orden = "idtipotasa";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 600) {
          var descripcion = [];
          for (let i = 0; i < response.data.length; i++) {
            descripcion.push({ descripcion: response.data[i].descripcion });
          }
          setDescricion(descripcion);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("anioactu"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);
    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
    seleccionarRegistros();
  }, []);

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const validar = () => {
    let sigue = true;

    if (props.tabla === 5) {
      console.log('holaaaaaaaaaaaaaaa')
      if (txtDesde.current.value === "") {
        setTitulo("Notificacion");
        setMsg("Debe Ingresar el sector de inicio");
        setMostrar(true);
        txtDesde.current.focus();
        sigue = false;
      } else if (txtHasta.current.value === "") {
        setTitulo("Notificacion");
        setMsg("Debe Ingresar el sector fin");
        setMostrar(true);
        txtHasta.current.focus();
        sigue = false;
      } else if (txtDesde.current.value > txtHasta.current.value) {
        setTitulo("Notificacion");
        setMsg("El sector de inicio no debe ser mayor al de fin");
        setMostrar(true);
        sigue = false;
        txtDesde.current.value = "";
        txtHasta.current.value = "";
        txtDesde.current.focus();
      }
    } else if (props.tabla === 6) {
      if (!txtTodo.current.checked && !txtPorRenta.current.checked) {
        setTitulo("Notificacion");
        setMsg("Debe Ingresar un tipo de busqueda");
        setMostrar(true);
        sigue = false;
      } else if (txtPorRenta.current.checked && txtRenta.current.value === "") {
        setTitulo("Notificacion");
        setMsg("Debe Seleccionar una renta");
        txtPorRenta.current.focus();
        setMostrar(true);
        sigue = false;
      } else if (txtAnio.current.value === "") {
        setTitulo("Notificacion");
        setMsg("Debe Escoger un año");
        txtAnio.current.focus();
        setMostrar(true);
        sigue = false;
      }
    } else if (txtTipoContri.current.value === "") {
      setTitulo("Notificacion");
      setMsg("Debe seleccionar un tipo de renta");
      setMostrar(true);
      txtTipoContri.current.focus();
      sigue = false;
    } else if (
      !chkActivo.current.checked &&
      !chkInactivo.current.checked &&
      !chkClausurado.current.checked &&
      !chkFiscal.current.checked &&
      !chkNotificado.current.checked &&
      !chkDepLegal.current.checked &&
      !chkExonerado.current.checked &&
      !chkRevCerrado.current.checked
    ) {
      setTitulo("Notificacion");
      setMsg("Debe seleccionar un Status");
      setMostrar(true);
      sigue = false;
    }

    if (sigue) {
      imprimirReporte();
    }
  };

  const salir = (e) => {
    e.preventDefault();
    props.setShow(false);
    props.setTabla()

  };

  const cancelar = () => {
    if (props.tabla === 5) {
      txtDesde.current.value = "";
      txtHasta.current.value = "";
      txtTipoContri.current.value = "";
      chkActivo.current.checked = false;
      chkInactivo.current.checked = false;
      chkClausurado.current.checked = false;
      chkFiscal.current.checked = false;
      chkNotificado.current.checked = false;
      chkDepLegal.current.checked = false;
      chkExonerado.current.checked = false;
      chkRevCerrado.current.checked = false;
    } else if (props.tabla === 6) {
      txtTodo.current.checked = false;
      txtPorRenta.current.checked = false;
      txtAnio.current.value = "";
      setVisible("hidden");
      txtRenta.current.value = "";
      txtTipoContri.current.value = "";
      chkActivo.current.checked = false;
      chkInactivo.current.checked = false;
      chkClausurado.current.checked = false;
      chkFiscal.current.checked = false;
      chkNotificado.current.checked = false;
      chkDepLegal.current.checked = false;
      chkExonerado.current.checked = false;
      chkRevCerrado.current.checked = false;
    }
    if (txtTipo.current) {
      txtTipo.current.value = "";
    }
    if (txtRenta.current) {
      txtRenta.current.value = "";
    }
  };

  const imprimirReporte = () => {
    var reporte = "";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "Ordenado por Sector";
    var sql5 = " ";
    let chk1 = chkActivo.current.checked ? "51," : "0,";
    let chk2 = chkInactivo.current.checked ? "52," : "0,";
    let chk3 = chkClausurado.current.checked ? "53," : "0,";
    let chk4 = chkFiscal.current.checked ? "54," : "0,";
    let chk5 = chkNotificado.current.checked ? "55," : "0,";
    let chk6 = chkDepLegal.current.checked ? "56," : "0,";
    let chk7 = chkExonerado.current.checked ? "57," : "0,";
    let chk8 = chkRevCerrado.current.checked ? "58" : "0";
    let status_cade = chk1 + chk2 + chk3 + chk4 + chk5 + chk6 + chk7 + chk8;
    if (props.tabla === 5) {
      reporte = "ListGenLicores";
      sql =
        "substr(SectorCatastral,1,2) between" +
        "'" +
        txtDesde.current.value +
        "'" +
        "and" +
        "'" +
        txtHasta.current.value +
        "'";
      sql2 =
        "Desde Sector:" +
        txtDesde.current.value +
        "  " +
        "Hasta Sector:" +
        txtHasta.current.value;
      sql3 = "cuenta";
      sql4 = "CONTRIBUYENTES " + txtTipoContri.current.value;
      if (txtTipoContri.current.value === "TODOS") {
        sql5 = " AND STATUS IN (" + status_cade + ")";
      } else {
        sql5 =
          " AND STATUS IN (" +
          status_cade +
          ") AND " +
          "TIPOCONTRIBUYENTE = '" +
          txtTipoContri.current.value +
          "'";
      }
      window.open(
        op.reportes +
        "/rentaslicores?reporte=" +
        reporte +
        "&sql=" +
        sql +
        "&sql2=" +
        sql2 +
        "&sql3=" +
        sql3 +
        "&sql4=" +
        sql4 +
        "&sql5=" +
        sql5,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else if (props.tabla === 6) {
      reporte = "Hac_LicorDeuda";
      sql = "ANIO <= " + txtAnio.current.value;
      sql2 = "DEUDA PENDIENTE AÑO " + txtAnio.current.value;
      sql4 = "CONTRIBUYENTES " + txtTipoContri.current.value;
      if (txtTipoContri.current.value === "TODOS") {
        sql5 = " AND STATUS IN (" + status_cade + ")";
      } else {
        sql5 =
          " AND STATUS IN (" +
          status_cade +
          ") AND " +
          "TIPOCONTRIBUYENTE = '" +
          txtTipoContri.current.value +
          "'";
      }
      if (txtTodo.current.checked) {
        sql = sql + " AND true";
      } else {
        sql =
          sql + " AND descripcion =" + "'" + txtTipoContri.current.value + "'";
      }
      window.open(
        op.reportes +
        "/rentaslicores?reporte=" +
        reporte +
        "&sql=" +
        sql +
        "&sql2=" +
        sql2 +
        "&sql4=" +
        sql4 +
        "&sql5=" +
        sql5,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const onChange = (event) => {
    let a = event.target;
    if (a.name === "inputDate") {
    } else if (a.name === "selectTipo") {
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0"> 2 {titulo1}</h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <h2 className="col-12 m-0 p-0 text-center fw-bold">{titulo2}</h2>
        {props.tabla === 6 && (
          <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
            <div className="col-auto m-0 p-0 d-flex gap-2">
              <span className="fw-bold">Buscar por:</span>
              <div className="col-auto m-0 p-0">
                <Radio
                  label="Todo."
                  ref={txtTodo}
                  name="radioDeclara"
                  id="radioDeclara1"
                  value="hidden"
                  onChange={(event) => setVisible(event.target.value)}
                />
              </div>
              <div className="col-auto m-0 p-0">
                <Radio
                  label="Por Renta."
                  ref={txtPorRenta}
                  name="radioDeclara"
                  id="radioDeclara2"
                  value="visible"
                  onChange={(event) => setVisible(event.target.value)}
                />
              </div>
            </div>
            <div className="col-2 m-0 p-0">
              <Select name="anioTasa" ref={txtRenta}>
                <option value="">Seleccionar</option>
                {descripcion &&
                  descripcion.map((a) => (
                    <option key={a.descripcion} value={a.descripcion}>
                      {a.descripcion}
                    </option>
                  ))}
              </Select>
            </div>
            <div className="col-3 m-0 p-0">
              <Select
                label="Año:"
                name="anioTasa"
                onChange={onChange}
                ref={txtAnio}
              >
                <option value="">Seleccionar</option>
                {anio &&
                  anio.map((a) => (
                    <option key={a.anio} value={a.anio}>
                      {a.anio}
                    </option>
                  ))}
              </Select>
            </div>
          </div>
        )}
        {props.tabla === 5 && (
          <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
            <div className="col-4 m-0 p-0">
              <Input
                label="Desde Sector Cobranza N°:"
                ref={txtDesde}
                id="inputCodigo"
              />
            </div>

            <div className="col-4 m-0 p-0">
              <Input
                label="Hasta Sector Cobranza N°:"
                ref={txtHasta}
                id="inputCodigo"
              />
            </div>
          </div>
        )}
        <div className="col-4 m-0 mb-2 p-0">
          <Select label="Tipo:" ref={txtTipoContri}>
            <option key="" value="">
              Seleccionar
            </option>
            <option key="1" value="PERMANENTE">
              PERMANENTE
            </option>
            <option key="2" value="TRANSEUNTE">
              TRANSEUNTE
            </option>
            <option key="1" value="EVENTUAL O AMBULANTE">
              EVENTUAL O AMBULANTE
            </option>
            <option key="1" value="IRREGULAR">
              IRREGULAR
            </option>
            <option key="1" value="REVISADO / CERRADO">
              REVISADO / CERRADO
            </option>
            <option key="1" value="TODOS">
              TODOS
            </option>
          </Select>
        </div>
        <div className="col-12 m-0 p-0 d-flex gap-2">
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Activo"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkActivo}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Inactivo"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkInactivo}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Clausurado"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkClausurado}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Fiscal"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkFiscal}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Notificado"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkNotificado}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Dep. Legal"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkDepLegal}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Exonerado"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkExonerado}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox
              label="Rev.Cerrado"
              id="chkActiviEconoConsul"
              name="accactividad"
              ref={chkRevCerrado}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton
          icon='fa-print'
          ref={btnAcepta}
          onClick={validar}
        >
          Imprimir
        </InfoButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
        <DangerButton
          ref={btnSalir}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
